import * as THREE from 'three';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import chroma from 'chroma-js';
import {
  MATERIAL_THICKNESS,
  OPACITY,
  PCB_SIZE,
  NOOP
} from '../../../constants/globals';
import Material from '../../../models/Material';

class MaterialBase extends Component {
  constructor(prop) {
    super(prop);
    this.state = {
      hovered: false,
    };
  }

  componentDidUpdate(prevProps) {
    const prevFreeze = prevProps.freezeMouseEvents;
    const { freezeMouseEvents: currFreeze } = this.props;

    // remove highglight when unfreeze the mouse events
    if (prevFreeze === true && currFreeze === false) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        hovered: false
      });
    }
  }

  _onMouseEnter() {
    const { setHoveredLayer, target } = this.props;
    this.setState({
      hovered: true,
    }, () => {
      setHoveredLayer && setHoveredLayer(target);
    });
  }

  _onMouseLeave() {
    const { unSetHoveredLayer, target } = this.props;
    this.setState({
      hovered: false,
    }, () => {
      unSetHoveredLayer && unSetHoveredLayer(target);
    });
  }

  _onClick() {
    const { onLayerClicked, target } = this.props;
    onLayerClicked(target);
  }

  _ref(material) {
    const { onCreate } = this.props;
    if (onCreate !== undefined) {
      onCreate(material);
    }
  }

  render() {
    const { position, thickness, color, freezeMouseEvents, hasWarning } = this.props,
      { hovered } = this.state,
      width  = PCB_SIZE.width,
      depth  = PCB_SIZE.depth,
      hoverHighlight = hovered,
      materialColor = hoverHighlight ? chroma(color).brighten(2.5).hex() : color
      // materialColor = hoverHighlight ? chroma(color).darken(2.5).hex() : color
    ;

    const onMouseEnter = freezeMouseEvents ? NOOP : this._onMouseEnter.bind(this);
    const onMouseLeave = freezeMouseEvents ? NOOP : this._onMouseLeave.bind(this);
    const onClick = freezeMouseEvents ? NOOP : this._onClick.bind(this);
    const ref = this._ref.bind(this);

    return (
      <group position={position}>
        <mesh
          castShadow
          receiveShadow
          ref={ref}
          onMouseLeave={onMouseLeave}
          onMouseEnter={onMouseEnter}
          onClick={onClick}
        >
          <boxGeometry
            width={width}
            height={thickness}
            depth={depth}
          />
          <meshLambertMaterial
            opacity={OPACITY}
            color={new THREE.Color(materialColor)}
            transparent
          />
        </mesh>
        {hasWarning ? (
          <mesh ignorePointerEvents>
            <boxGeometry
              width={width}
              height={thickness}
              depth={depth}
              widthSegments={10}
              heightSegments={2}
            />
            <materialResource
              resourceId="warningMaterial"
            />
          </mesh>
        ) : null}
        {hoverHighlight ? (
          <mesh ignorePointerEvents>
            <boxGeometry
              width={width}
              height={thickness}
              depth={depth}
            />
            <materialResource
              resourceId="highlightMaterial"
            />
          </mesh>
        ) : null}
      </group>
    );
  }
}

MaterialBase.propTypes = {
  position:  PropTypes.instanceOf(THREE.Vector3),
  color: PropTypes.number,
  thickness: PropTypes.number,
  freezeMouseEvents: PropTypes.bool,
  onLayerClicked: PropTypes.func,
  onCreate: PropTypes.func.isRequired,
  target: PropTypes.instanceOf(Material).isRequired,
  setHoveredLayer: PropTypes.func,
  unSetHoveredLayer: PropTypes.func,
  hasWarning: PropTypes.bool,
}

MaterialBase.defaultProps = {
  position: new THREE.Vector3(),
  color:    0xffffff,
  thickness: MATERIAL_THICKNESS,
  hasWarning: false,
  freezeMouseEvents: false,
  setHoveredLayer: null,
  unSetHoveredLayer: null,
  onLayerClicked: null,
}
export default MaterialBase;



// WEBPACK FOOTER //
// ./src/components/common/materials/MaterialBase.jsx